<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="2" />
    <h4>Tarifario por Prestador</h4>
    <hr />
    <!-- Filtros -->
    <div class="container mb-4">
      <div class="row g-3 align-items-end">
        <div class="col-md-3">
          <label class="form-label fw-bold">Prestador</label>
          <select v-model="filtroPrestador" class="form-select" @change="onCambioPrestador">
            <option value="">-- Seleccione un prestador --</option>
            <option
              v-for="p in prestadores"
              :key="p.idPrestador"
              :value="p.idPrestador"
            >
              {{ p.razonSocial }}
            </option>
          </select>
        </div>
        <div class="col-md-3">
          <label class="form-label fw-bold">Filtrar por Tarifario</label>
          <select v-model="filtroTarifario" class="form-select">
            <option value="">-- Todos los tarifarios --</option>
            <option
              v-for="t in tarifariosUnicos"
              :key="t"
              :value="t"
            >
              {{ t }}
            </option>
          </select>
        </div>
        <div class="col-md-2">
          <label class="form-label fw-bold">Estado</label>
          <select v-model="filtroEstado" class="form-select">
            <option value="">-- Todos --</option>
            <option value="1">Activo</option>
            <option value="0">Inactivo</option>
          </select>
        </div>
        <div class="col-md-2">
          <label class="form-label fw-bold">Buscar</label>
          <input
            v-model.trim="filtroTexto"
            type="text"
            class="form-control"
            placeholder="Código o nombre..."
          />
        </div>
        <div class="col-md-2 d-flex gap-1">
          <button
            @click="exportarCSV"
            class="btn btn-outline-success flex-fill"
            :disabled="listaFiltrada.length === 0"
            title="Exportar CSV"
          >
            <i class="material-icons" style="font-size:18px;vertical-align:middle">download</i>
          </button>
          <button
            @click="exportarExcel"
            class="btn btn-outline-primary flex-fill"
            :disabled="listaFiltrada.length === 0"
            title="Exportar Excel"
          >
            <i class="material-icons" style="font-size:18px;vertical-align:middle">grid_on</i>
          </button>
          <button
            @click="exportarPDF"
            class="btn btn-outline-danger flex-fill"
            :disabled="listaFiltrada.length === 0"
            title="Exportar PDF"
          >
            <i class="material-icons" style="font-size:18px;vertical-align:middle">picture_as_pdf</i>
          </button>
        </div>
      </div>
    </div>

    <!-- Mensaje: sin prestador seleccionado -->
    <div v-if="!filtroPrestador" class="alert alert-info mt-3" role="alert">
      Seleccione un prestador para ver sus tarifas.
    </div>

    <!-- Cargando -->
    <div v-else-if="cargando" class="text-center my-4">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Cargando...</span>
      </div>
    </div>

    <template v-else>
      <!-- Selector registros por página -->
      <div class="d-flex justify-content-end align-items-center gap-2 mb-2" v-if="listaFiltrada.length > 0">
        <label class="form-label mb-0 small fw-bold">Mostrar</label>
        <select
          v-model.number="elementosPorPagina"
          class="form-select form-select-sm"
          style="width:75px"
          @change="aplicarPaginacion(1)"
        >
          <option :value="10">10</option>
          <option :value="25">25</option>
          <option :value="50">50</option>
          <option :value="100">100</option>
        </select>
        <span class="small text-muted">registros</span>
      </div>

      <!-- Tabla -->
      <div class="table-responsive" v-if="listaFiltrada.length > 0">
        <table class="table table-hover table-bordered table-sm">
          <thead class="table-dark">
            <tr>
              <th class="text-center">#</th>
              <th class="th-sort" @click="ordenarPor('elementoCodigo')">
                Código <span>{{ iconOrden('elementoCodigo') }}</span>
              </th>
              <th class="th-sort" @click="ordenarPor('elementoNombre')">
                Elemento <span>{{ iconOrden('elementoNombre') }}</span>
              </th>
              <th class="th-sort" @click="ordenarPor('tarifaConvNombre')">
                Tarifario <span>{{ iconOrden('tarifaConvNombre') }}</span>
              </th>
              <th class="th-sort text-end" @click="ordenarPor('valor')">
                Valor <span>{{ iconOrden('valor') }}</span>
              </th>
              <th class="th-sort text-center" @click="ordenarPor('estado')">
                Estado <span>{{ iconOrden('estado') }}</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, idx) in datosPaginados" :key="item.idTarifaPres">
              <td class="text-center">{{ (paginaActual - 1) * elementosPorPagina + idx + 1 }}</td>
              <td>{{ item.elementoCodigo }}</td>
              <td>{{ item.elementoNombre }}</td>
              <td>{{ item.tarifaConvNombre }}</td>
              <td class="text-end">{{ formatoMoneda(item.valor) }}</td>
              <td class="text-center">
                <span class="badge" :class="item.estado === 1 ? 'bg-success' : 'bg-danger'">
                  {{ item.estado === 1 ? 'Activo' : 'Inactivo' }}
                </span>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr class="table-secondary">
              <td colspan="6" class="text-end fw-bold small">
                Mostrando {{ datosPaginados.length }} de {{ listaFiltrada.length }} registros
              </td>
            </tr>
          </tfoot>
        </table>
      </div>

      <!-- Sin resultados -->
      <div v-if="listaFiltrada.length === 0 && lista.length > 0" class="alert alert-warning mt-3" role="alert">
        No se encontraron registros con los filtros aplicados.
      </div>
      <div v-if="lista.length === 0" class="alert alert-warning mt-3" role="alert">
        Este prestador no tiene tarifas registradas.
      </div>

      <!-- Paginación -->
      <div
        class="d-flex justify-content-between align-items-center mt-3"
        v-if="listaFiltrada.length > 0"
      >
        <span class="small text-muted">
          Página {{ paginaActual }} de {{ totalPaginas() }} —
          {{ listaFiltrada.length }} registros
        </span>
        <nav aria-label="Paginación">
          <ul class="pagination pagination-sm mb-0">
            <li class="page-item" :class="{ disabled: paginaActual === 1 }">
              <a class="page-link" href="#" @click.prevent="aplicarPaginacion(1)">«</a>
            </li>
            <li class="page-item" :class="{ disabled: paginaActual === 1 }">
              <a class="page-link" href="#" @click.prevent="getPreviousPage">‹</a>
            </li>
            <li
              v-for="pagina in paginasVisibles"
              :key="pagina"
              class="page-item"
              :class="{ active: pagina === paginaActual, disabled: pagina === '...' }"
            >
              <a
                class="page-link"
                href="#"
                @click.prevent="pagina !== '...' && aplicarPaginacion(pagina)"
              >
                {{ pagina }}
              </a>
            </li>
            <li class="page-item" :class="{ disabled: paginaActual === totalPaginas() }">
              <a class="page-link" href="#" @click.prevent="getNextPage">›</a>
            </li>
            <li class="page-item" :class="{ disabled: paginaActual === totalPaginas() }">
              <a class="page-link" href="#" @click.prevent="aplicarPaginacion(totalPaginas())">»</a>
            </li>
          </ul>
        </nav>
      </div>
    </template>

    <Footer />
  </div>
</template>

<script>
import api from "@/services/api";
import Layout from "@/components/Layout.vue";
import Footer from "@/components/Footer.vue";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";

export default {
  components: { Layout, Footer },
  data() {
    return {
      lista:              [],
      prestadores:        [],
      filtroPrestador:    "",
      filtroTarifario:    "",
      filtroEstado:       "",
      filtroTexto:        "",
      idEmpresa:          0,
      cargando:           false,
      // Paginación
      elementosPorPagina: 10,
      datosPaginados:     [],
      paginaActual:       1,
      // Ordenamiento
      campoOrden:         "elementoNombre",
      ascendente:         true,
    };
  },
  computed: {
    tarifariosUnicos() {
      const set = new Set(this.lista.map((item) => item.tarifaConvNombre).filter(Boolean));
      return [...set].sort((a, b) => a.localeCompare(b, "es"));
    },
    listaFiltrada() {
      const campo   = this.campoOrden;
      const texto   = this.filtroTexto.toLowerCase();
      return this.lista
        .filter((item) => {
          const porTarifario = this.filtroTarifario ? item.tarifaConvNombre === this.filtroTarifario : true;
          const porEstado    = this.filtroEstado !== "" ? item.estado === Number(this.filtroEstado) : true;
          const porTexto     = texto
            ? (item.elementoCodigo ?? "").toLowerCase().includes(texto) ||
              (item.elementoNombre ?? "").toLowerCase().includes(texto)
            : true;
          return porTarifario && porEstado && porTexto;
        })
        .sort((a, b) => {
          let va = a[campo] ?? "";
          let vb = b[campo] ?? "";
          if (campo === "estado" || campo === "valor") {
            return this.ascendente ? va - vb : vb - va;
          }
          const cmp = String(va).localeCompare(String(vb), "es");
          return this.ascendente ? cmp : -cmp;
        });
    },
    paginasVisibles() {
      const total  = this.totalPaginas();
      const actual = this.paginaActual;
      const delta  = 2;
      const rango  = [];
      for (
        let i = Math.max(2, actual - delta);
        i <= Math.min(total - 1, actual + delta);
        i++
      ) {
        rango.push(i);
      }
      if (rango.length && rango[0] > 2)                        rango.unshift("...");
      if (rango.length && rango[rango.length - 1] < total - 1) rango.push("...");
      const paginas = [1];
      rango.forEach((p) => paginas.push(p));
      if (total > 1) paginas.push(total);
      return paginas;
    },
  },
  watch: {
    listaFiltrada() {
      this.aplicarPaginacion(1);
    },
  },
  mounted() {
    this.idEmpresa = window.sessionStorage.getItem("idEmpresa");
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
    this.cargarPrestadores();
  },
  methods: {
    // ── Formato ────────────────────────────────────────────
    formatoMoneda(valor) {
      const n = Number(valor ?? 0);
      return n.toLocaleString("es-EC", { style: "currency", currency: "USD" });
    },
    // ── Ordenamiento ───────────────────────────────────────
    ordenarPor(campo) {
      if (this.campoOrden === campo) {
        this.ascendente = !this.ascendente;
      } else {
        this.campoOrden = campo;
        this.ascendente = true;
      }
      this.aplicarPaginacion(1);
    },
    iconOrden(campo) {
      if (this.campoOrden !== campo) return "⇅";
      return this.ascendente ? "↑" : "↓";
    },
    // ── Paginación ─────────────────────────────────────────
    totalPaginas() {
      return Math.max(
        1,
        Math.ceil(this.listaFiltrada.length / this.elementosPorPagina)
      );
    },
    aplicarPaginacion(noPagina) {
      this.paginaActual   = noPagina;
      const ini           = (noPagina - 1) * this.elementosPorPagina;
      this.datosPaginados = this.listaFiltrada.slice(ini, ini + this.elementosPorPagina);
    },
    getPreviousPage() {
      if (this.paginaActual > 1) this.aplicarPaginacion(this.paginaActual - 1);
    },
    getNextPage() {
      if (this.paginaActual < this.totalPaginas())
        this.aplicarPaginacion(this.paginaActual + 1);
    },
    // ── Carga de datos ─────────────────────────────────────
    async cargarPrestadores() {
      try {
        const res = await api.get(`/vwprestadors/idempresa/${this.idEmpresa}`);
        this.prestadores = (Array.isArray(res.data) ? res.data : []).sort((a, b) =>
          (a.razonSocial ?? "").localeCompare(b.razonSocial ?? "", "es")
        );
      } catch (error) {
        console.error("Error cargando prestadores:", error);
      }
    },
    onCambioPrestador() {
      this.filtroTarifario = "";
      this.filtroEstado    = "";
      this.filtroTexto     = "";
      if (this.filtroPrestador) {
        this.cargarTarifas();
      } else {
        this.lista = [];
      }
    },
    async cargarTarifas() {
      this.cargando = true;
      try {
        const res   = await api.get(`/vwtarifapress/idprestador/${this.filtroPrestador}`);
        this.lista  = Array.isArray(res.data) ? res.data : [];
        this.aplicarPaginacion(1);
      } catch (error) {
        console.error("Error cargando las tarifas:", error);
        this.lista = [];
      } finally {
        this.cargando = false;
      }
    },
    // ── Exportar CSV (separador ";") ───────────────────────
    exportarCSV() {
      const escape = (val) => {
        if (val === null || val === undefined) return "";
        const str = String(val).replace(/"/g, '""');
        return str.includes(";") || str.includes("\n") ? `"${str}"` : str;
      };
      const headers = ["#", "Código", "Elemento", "Tarifario", "Valor", "Estado"];
      const rows = [
        headers.join(";"),
        ...this.listaFiltrada.map((item, idx) =>
          [
            idx + 1,
            item.elementoCodigo,
            item.elementoNombre,
            item.tarifaConvNombre,
            item.valor,
            item.estado === 1 ? "Activo" : "Inactivo",
          ]
            .map(escape)
            .join(";")
        ),
      ];
      const bom  = "\uFEFF";
      const blob = new Blob([bom + rows.join("\n")], { type: "text/csv;charset=utf-8;" });
      const url  = URL.createObjectURL(blob);
      const a    = document.createElement("a");
      a.href     = url;
      a.download = "reporte_tarifas_prestador.csv";
      a.click();
      URL.revokeObjectURL(url);
    },
    // ── Exportar Excel (.xlsx) ──────────────────────────────
    exportarExcel() {
      const filas = this.listaFiltrada.map((item, idx) => ({
        "#":                       idx + 1,
        "Código":                  item.elementoCodigo,
        "Elemento":                item.elementoNombre,
        "Tarifario":               item.tarifaConvNombre,
        "Valor":                   Number(item.valor ?? 0),
        "Estado":                  item.estado === 1 ? "Activo" : "Inactivo",
      }));

      const hoja  = XLSX.utils.json_to_sheet(filas);
      // Ancho de columnas aproximado
      hoja["!cols"] = [
        { wch: 5 },  // #
        { wch: 12 }, // Código
        { wch: 60 }, // Elemento
        { wch: 30 }, // Tarifario
        { wch: 12 }, // Valor
        { wch: 10 }, // Estado
      ];
      // Formato de moneda en la columna Valor
      const rango = XLSX.utils.decode_range(hoja["!ref"]);
      for (let fila = rango.s.r + 1; fila <= rango.e.r; fila++) {
        const celda = hoja[XLSX.utils.encode_cell({ r: fila, c: 4 })];
        if (celda) celda.z = '"$"#,##0.00';
      }

      const libro = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(libro, hoja, "Tarifas");
      XLSX.writeFile(libro, "reporte_tarifas_prestador.xlsx");
    },
    // ── Exportar PDF ───────────────────────────────────────
    exportarPDF() {
      const doc = new jsPDF();
      doc.setFontSize(14);
      doc.text("Reporte de Tarifas por Prestador", 14, 15);
      autoTable(doc, {
        startY: 20,
        head: [["#", "Código", "Elemento", "Tarifario", "Valor", "Estado"]],
        body: this.listaFiltrada.map((item, idx) => [
          idx + 1,
          item.elementoCodigo,
          item.elementoNombre,
          item.tarifaConvNombre,
          this.formatoMoneda(item.valor),
          item.estado === 1 ? "Activo" : "Inactivo",
        ]),
        styles:     { fontSize: 9 },
        headStyles: { fillColor: [33, 37, 41] }, // table-dark equivalente
      });
      doc.save("reporte_tarifas_prestador.pdf");
    },
  },
};
</script>

<style scoped>
.th-sort {
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
}
.th-sort:hover {
  background-color: #3d5166;
}
.table-hover tbody tr {
  cursor: pointer;
}
</style>